import { useLingui } from '@lingui/react';
import { Stack } from '@mantine/core';
import { AsideCommandItem } from './AsideCommandItem';
export const AsideCommand: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack gap={10}>
      <AsideCommandItem imgUrl="/assets/sticker/icons-3d/1.svg" command={i18n._('/Coindrop')} description={i18n._('Tip group')} />
      <AsideCommandItem imgUrl="/assets/sticker/icons-3d/2.svg" command={i18n._('/User')} description={i18n._('@User view user')} />
      <AsideCommandItem imgUrl="/assets/sticker/icons-3d/3.svg" command={i18n._('/Tip')} description={i18n._('@User tip user')} />
      <AsideCommandItem imgUrl="/assets/sticker/icons-3d/4.svg" command={i18n._('/Rain')} description={i18n._('Make it rain')} />
    </Stack>;
};